// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2JXQL","title":"AfterFrontImage_title__R6T9X"};